import axios from 'axios';
import qs from 'qs'
let util = {

};
util.title = function (title) {
    title = title || 'Teyes 常见问题';
    window.document.title = title;
};
const ajaxUrl = process.env.NODE_ENV === 'development'
    ? 'http://127.0.0.1/teyes_faq/api/index.php'
    : process.env.NODE_ENV === 'production'
    ? 'api/index.php'
    : 'api/index.php';

const smsurl = process.env.NODE_ENV === 'development'
    ? 'http://192.168.1.103/teyes_faq/api/sms/smsService.php'
    : process.env.NODE_ENV === 'production'
    ? 'api/sms/smsService.php'
    : 'api/sms/smsService.php';

util.ajax = axios.create({
    timeout: 30000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [function (data) {
        return qs.stringify(data)
    }],
    methods:'post',
    baseURL: ajaxUrl,
});

util.server = ajaxUrl

util.ajaxSms = axios.create({
    timeout: 30000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [function (data) {
        return qs.stringify(data)
    }],
    methods:'post',
    baseURL: smsurl,
});

util.toDefaultPage = function (routers, name, route, next) {
    let len = routers.length;
    let i = 0;
    let notHandle = true;
    while (i < len) {
        if (routers[i].name === name && routers[i].redirect === undefined) {
            route.replace({
                name: routers[i].children[0].name
            });
            notHandle = false;
            next();
            break;
        }
        i++;
    }
    if (notHandle) {
        next();
    }
};

export default util;



// WEBPACK FOOTER //
// ./src/util.js